import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    get_Service_Type,
    get_Service_ApplicableTo,
    get_Pricing_Rule,
    create_Service,
    UpdateService,
    GetserviceById

} from '../../../Service/Pricing/Service'



export const getServiceType = createAsyncThunk("getServiceType", async (data) => {

    try {

        const res = await get_Service_Type(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const getServiceApplicable = createAsyncThunk("getServiceApplicable", async (data) => {

    try {
        const res = await get_Service_ApplicableTo(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const getPricingRule = createAsyncThunk("chargebasisdata", async (data) => {

    try {
        const res = await get_Pricing_Rule(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const createService = createAsyncThunk("createService", async (data) => {

    try {
        const res = await create_Service(data);
        return await res;
    } catch (err) {
        return err;
    }
});


export const updateService = createAsyncThunk("updateService", async (data) => {

    try {
        const res = await UpdateService(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const GetserviceByIdApi = createAsyncThunk("GetserviceById", async (data) => {

    try {
        const res = await GetserviceById(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const getChargBasesData = createAsyncThunk("chargebasisdata1", async (data) => {

    try {
        const res = await get_Pricing_Rule(data);
        return await res;
    } catch (err) {
        return err;
    }
});


const ServiceSlice = createSlice({
    name: "ServiceSlice",
    initialState: {
        isLoading: false,
        isError: false,
        getservicetype: [],
        getserviceapplicable: [],
        getpricingrule: [],
        createservice: [],
        updateService: [],
        getChargBasesData: [],
        getServiceById: [],

    },


    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getServiceType.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getServiceType.fulfilled, (state, action) => {
                state.isLoading = false;
                state.getservicetype = action.payload;
            })
            .addCase(getServiceType.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })
            .addCase(getServiceApplicable.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getServiceApplicable.fulfilled, (state, action) => {
                state.isLoading = false;
                state.getserviceapplicable = action.payload;
            })
            .addCase(getServiceApplicable.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })
            .addCase(getPricingRule.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getPricingRule.fulfilled, (state, action) => {
                state.isLoading = false;
                state.getpricingrule = action.payload;
            })
            .addCase(getPricingRule.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })
            .addCase(createService.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(createService.fulfilled, (state, action) => {
                state.isLoading = false;
                state.createservice = action.payload;
            })
            .addCase(createService.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })
            .addCase(updateService.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(updateService.fulfilled, (state, action) => {
                state.isLoading = false;
                state.updateService = action.payload;
            })
            .addCase(updateService.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })
            .addCase(getChargBasesData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getChargBasesData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.getChargBasesData = action.payload;
            })
            .addCase(getChargBasesData.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })
            .addCase(GetserviceByIdApi.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(GetserviceByIdApi.fulfilled, (state, action) => {
                state.isLoading = false;
                state.getServiceById = action.payload;
            })
            .addCase(GetserviceByIdApi.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })
    },

});

export default ServiceSlice;
